jQuery(function ($) {
    // Query all .form-control elements in form groups and rows
    let formFields = $('.form-control, .custom-select', '.form-group, .form-row');

    formFields.each(function () {
        let field = $(this);
        var label = field.prev('label');

        // Skip if no input found
        if (!field.length) {
            return;
        }

        function checkInput() {
            // Floating label
            if (field.is(':focus') || field.val().length > 0 || (field.attr('placeholder') && field.attr('placeholder').length > 0)) {
                label.addClass('d-none');
            } else {
                label.removeClass('d-none');
            }

            // Active style if input has content
            if (!field.hasClass('is-valid') && !field.hasClass('is-invalid')) {
                field.toggleClass('active', field.val().length > 0);
            }
        }

        field.on('focus blur keyup', checkInput);

        checkInput();
    });
});

document.addEventListener('DOMContentLoaded', function(){ 

    let form = document.querySelector(".comment-form");

    const isBetween = (length, min, max) => length < min || length > max ? false : true;

    const isEmailValid = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
    
    if(form){

        form.addEventListener("submit", function(e){    
            e.preventDefault();

            let requiredElements = form.querySelectorAll("[required]");
            let valid = true;
            
            if(requiredElements){

                for (var i = 0; i < requiredElements.length; i++){
                    
                    let element = requiredElements[i];

                    parentDiv = element.parentNode;

                    if(parentDiv){    
                        
                        // remove errors if exists
                        let parentDiv_children = parentDiv.querySelectorAll('.comment-form-error');

                        if(parentDiv_children.length){
                            parentDiv_children.forEach(e => e.remove());
                        }

                        if(element.value == ''){ // if empty input
                            parentDiv.innerHTML = parentDiv.innerHTML + '<span class="comment-form-error">Palun täitke see väli!<span>';
                            valid = false;
                        }else{
                            if(element.name == 'comment') {
                                console.log(element.value.length);
                                if(!isBetween(element.value.length, 10, 65525)){
                                    parentDiv.innerHTML = parentDiv.innerHTML + '<span class="comment-form-error">Jälgi oma kommentaari pikkust!<span>';
                                    valid = false;
                                }
                            }
                            if(element.type == 'email'){
                                if(!isEmailValid(element.value)){
                                    parentDiv.innerHTML = parentDiv.innerHTML + '<span class="comment-form-error">Palun sisestage oma e-posti aadressi õigesti!.<span>';
                                    valid = false;
                                }
                            }
                        }
                    }
                }
            }
            if(valid){
                console.log(valid);
                grecaptcha.ready(function() {
                    grecaptcha.execute("6LeQCrciAAAAAOGpUCMgQ1v4_4Wg-d1G4D7DO-qt", {action: "submit"}).then(function(token) {
                        console.log(token);
                        document.getElementById("recaptchaResponse").value = token;
                        HTMLFormElement.prototype.submit.call(form);
                    });
                });
            }
        });
    }

}, false);